export default "/// <reference types=\"vite/client\" />\n"